'use client';
import { ReactNode, useEffect, useState } from 'react';
import Tooltip from '@mui/material/Tooltip';
import Message from '@primitives/BaseTooltip/_Message';

export interface BaseTooltipProps {
  text: string;
  border?: boolean;
  label: string;
  closeIcon?: boolean;
  closeLabel: string;
  children: ReactNode;
  onToggleOpen?: (open: boolean) => void;
}

const BaseTooltip = ({
  text,
  border = false,
  label,
  closeIcon = false,
  closeLabel,
  children,
  onToggleOpen,
}: BaseTooltipProps) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    onToggleOpen?.(open);
  }, [open, onToggleOpen]);

  return (
    <Tooltip
      title={
        <Message text={text} closeIcon={closeIcon} closeLabel={closeLabel} setOpen={setOpen} />
      }
      arrow
      enterTouchDelay={30}
      leaveTouchDelay={0}
      open={open}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      aria-label={label || 'Open Info Dialog'}
      role="tooltip"
      tabIndex={0}
      slotProps={{
        tooltip: {
          className: 'bg-neutral-600 rounded-none',
          style: border ? { border: '1px solid var(--tra-color-neutral-500)' } : undefined,
        },
        arrow: {
          sx: {
            '&::before': {
              backgroundColor: 'var(--tra-color-neutral-600)',
              border: border ? '1px solid var(--tra-color-neutral-500)' : 0,
            },
          },
        },
      }}
    >
      <span className="cursor-pointer">{children}</span>
    </Tooltip>
  );
};

export default BaseTooltip;
